export const usePermissions = ({ userPermissions }) => {
    function hasPermission(moduleName, permission) {
        const permissions = Array.isArray(permission) ? permission : [permission];
        if (!userPermissions[moduleName] || !Array.isArray(userPermissions[moduleName]) || userPermissions[moduleName].length === 0)
            return false;
        return permissions.some(permission => userPermissions[moduleName].includes(permission));
    }
    return { hasPermission };
};
